/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/819/interface/api/cat_12707
 */

import { message } from 'ant-design-vue'
import {
  abLayer_allocate_post,
  abLayer_page_post,
  abLayer_queryAll_post,
  abLayer_remove_get,
  abLayer_save_post
} from 'server/modules/12707'

// 分配实验层流量
export const abLayer_allocate_post_ = async function(params) {
  const { success, data, retInfo } = await abLayer_allocate_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分页查询
export const abLayer_page_post_ = async function(params) {
  const { success, data, retInfo } = await abLayer_page_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询所有实验层
export const abLayer_queryAll_post_ = async function(params) {
  const { success, data, retInfo } = await abLayer_queryAll_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 删除实验层
export const abLayer_remove_get_ = async function(params) {
  const { success, data, retInfo } = await abLayer_remove_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 保存实验层
export const abLayer_save_post_ = async function(params) {
  const { success, data, retInfo } = await abLayer_save_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
